// Turn bare URLs in user text into clickable anchors. The output is HTML that
// MUST be passed through sanitizeHtml() before rendering (DOMPurify validates
// the href — blocking javascript:/data: — and strips any other markup the user
// typed). Used for bios and DMs so links are clickable without allowing XSS.
//
// Matches http(s):// and www. URLs up to the next whitespace or '<'. The
// surrounding non-URL text is left as-is and cleaned by DOMPurify downstream.
const URL_RE = /\b(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;

export const linkify = (text) => {
  if (!text) return "";
  return String(text).replace(URL_RE, (url) => {
    // Trim trailing punctuation that's usually sentence punctuation, not URL.
    const trailingMatch = url.match(/[.,!?;:)\]]+$/);
    const trailing = trailingMatch ? trailingMatch[0] : "";
    const clean = trailing ? url.slice(0, -trailing.length) : url;
    const href = clean.startsWith("http") ? clean : `https://${clean}`;
    return `<a href="${href}" target="_blank" rel="noopener noreferrer nofollow">${clean}</a>${trailing}`;
  });
};
